import type { MetaFunction } from 'react-router';
import { getRepubMetaFromRepub } from '@cx-web/utils';
import { getCanonicalURL } from '@cx-web/utils/getCanonicalURL';

import { type loader } from './loader';

export const meta: MetaFunction<never, { [routeId: string]: typeof loader }> = ({ location, matches }) => {
  const layoutMatch = matches.find(match => /layout$/.test(match.id));
  const repub = layoutMatch?.data?.repub;
  const data = matches.find(match => /trends$/.test(match.id))?.data;

  if (!repub) {
    throw new Error('Repub data is missing from layout match');
  }

  const { repubIs } = getRepubMetaFromRepub(repub);

  const brandName = repubIs.WS ? 'WhoScored Plus' : 'Oddschecker Plus';

  return [
    { title: `Betting Trends & Betting Stats | ${brandName}` },
    {
      name: 'description',
      content: `Betting Trends & Betting Stats | ${brandName}`,
    },
    {
      tagName: 'link',
      rel: 'canonical',
      href: getCanonicalURL(data?.url.toString(), location.pathname),
    },
  ];
};
